<template>
    <div>

        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">用户管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>用户名</span>
                            <el-input v-model="condition.name" placeholder="请输入用户名" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>角色</span>
                            <el-select v-model="condition.role_id" placeholder="请选择角色"
                                style="width: 70%; margin-left: 10px;" filterable>
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in roleList" :key="item.id" :label="item.role_name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>手机号</span>
                            <el-input v-model="condition.phone" placeholder="请输入手机号" style="width: 60%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>姓名</span>
                            <el-input v-model="condition.staff_name" placeholder="请输入姓名"
                                style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="8">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                @click="Find">
                                查询</el-button>
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                @click="Del(null)">
                                删除</el-button>
                            <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">
                                新增</el-button>
                        </el-col>

                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="540"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
                                </el-table-column>
                                <el-table-column prop="name" align="name" label="用户名"></el-table-column>
                                <el-table-column prop="role_name" align="center" label="角色"></el-table-column>
                                <el-table-column prop="staff_name" align="center" label="姓名"></el-table-column>
                                <el-table-column prop="phone" align="center" label="手机号"></el-table-column>
                                <el-table-column prop="mailbox" align="center" label="邮箱"></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)">
                                        <img src="../../../assets/删除.png" @click="Del(scope.row.id)"
                                            style="margin-left: 10px" />
                                        <img src="../../../assets/恢复默认.png" @click="Default(scope.row.id)"
                                            style="margin-left: 10px" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <div>
            <el-dialog :title="from.id == null || from.id == '' ? '添加用户' : '修改用户'" :visible.sync="dialogVisible" width="40%"
                :close-on-click-modal="false" :center="true">
                <add ref="add"></add>
            </el-dialog>
        </div>

    </div>
</template>

<script>
import add from './User_add.vue';

import axios from "axios";
export default {
    components: {
        add: add,
    },
    data() {
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],

            //页面相关
            dialogVisible: false,

            //员工下拉
            staffList: [],
            //角色下拉
            roleList: [],

            //条件
            condition: {
                name: "",
                role_id: "",
                phone: "",
                staff_name: "",
            },

            //详情
            from: {
                id: "",
                name: "",
                pwd: "",
                role_id: "",
                staff_id: "",
                staff_name: "",
                phone: "",
                mailbox: "",
            },

            //复选框ids
            ids: [],
        };
    },
    methods: {
        //返回
        Return(e) {
            this.dialogVisible = false;
            this.Find();
        },
        //列表点击复选框
        handleSelectionChange(e) {
            this.ids = [];
            e.forEach(item => {
                this.ids.push(item.id);
            })
        },
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },
        //查询
        Find() {
            const url = this.$globals.http + "user/find";
            axios.post(url, {
                page_num: this.page_num,
                page_size: this.page_size,
                name: this.condition.name,
                role_id: this.condition.role_id,
                phone: this.condition.phone,
                staff_name: this.condition.staff_name,
            }).then((response) => {
                var code = response.data.code;
                var data = response.data.data;

                if (code === '200') {

                    this.tableData = data.list;
                    this.total = data.total;

                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }).catch((error) => {
                console.log(error)
                this.$message.error("服务器未响应！请稍后重试");
            })
        },
        //新增页面
        AddFrom() {
            this.trash();
            this.dialogVisible = true;
        },
        //编辑页面
        UpdateFrom(e) {
            this.from.id = e.id;
            this.from.name = e.name;
            this.from.pwd = e.pwd;
            this.from.role_id = e.role_id;
            this.from.staff_id = e.staff_id;
            this.from.phone = e.phone;
            this.from.mailbox = e.mailbox;
            this.dialogVisible = true;
        },
        //删除
        Del(e) {
            var ids;
            if (e === null || e === "" || e === undefined) {
                if (this.ids === null || this.ids.length <= 0) {
                    this.$message.warning("请先选择操作数据！");
                    return false;
                }
                ids = this.ids;
            } else {
                ids = [e];
            }

            const url = this.$globals.http + "user/del";
            axios.post(url, {
                ids: ids,
            }).then((response) => {
                var code = response.data.code;
                var data = response.data.data;

                if (code === '200') {

                    this.$message.success(data);
                    this.Find();

                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }).catch((error) => {
                console.log(error)
                this.$message.error("服务器未响应！请稍后重试");
            })
        },
        Default(e) {
            const url = this.$globals.http + "user/recovery";
            axios.post(url, {
                id: e,
            }).then((response) => {
                var code = response.data.code;
                var data = response.data.data;

                if (code === '200') {
                    this.$message.success(data);
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }).catch((error) => {
                console.log(error)
                this.$message.error("服务器未响应！请稍后重试");
            })
        },
        //清除数据
        trash() {
            this.from.mailbox = "";
            this.from.phone = "";
            this.from.staff_id = "";
            this.from.role_id = "";
            this.from.pwd = "";
            this.from.name = "";
            this.from.id = "";
        }
    },
    async created() {
        this.Find();


        //初始化角色下拉
        var roleList = await this.$globals.AxiosPost("role/selectFind", {});
        this.roleList = roleList.data;

        //初始化员工下拉
        var staffList = await this.$globals.AxiosPost("staff/selectFind", {});
        this.staffList = staffList.data;



    }
}
</script>

<style scoped="scoped">
>>>.el-button:hover {
    background-color: #FFFFFF;
}

>>>.el-button:focus {
    background-color: #FFFFFF;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #006E4B;
}

>>>.el-input__inner:focus {
    border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
    border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006E4B;
    border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
    border-color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// User.vue?36cbfba9